import { Injectable } from '@angular/core';
import { IUseCase } from '@karma-games/angular-devkit/src/lib/interfaces';
import { StatisticsRepository } from '../statistics.repository';
import { ERoundState, IRound, IRoundBet } from '../../core/round/interfaces';
import { RoundRepository } from '../../core/round/round.repository';
import { IUserBet } from '../../core/round/store/interfaces';
import { combineLatestWith, filter, map, take } from 'rxjs/operators';
import { distinctUntilChanged, Observable } from 'rxjs';

@Injectable()
export class AddRemoveUserRoundBetRecordsUseCase implements IUseCase<IRoundBet[], void> {

    constructor(
        private roundRepository: RoundRepository,
        private statisticsRepository: StatisticsRepository
    ) {
    }

    execute(): Observable<void> {
        return this.roundRepository.get().pipe(
            filter(round => round.state === ERoundState.Playing),
            map((round: IRound) => round.userBets),
            distinctUntilChanged((prev: IUserBet[], curr: IUserBet[]) => {
                return prev.length === curr.length && this.isRoundIdEqual(prev, curr);
            }),
            combineLatestWith(this.statisticsRepository.getMyBets().pipe(take(1))),
            map(this.onUserBetsChange)
        );
    }

    private onUserBetsChange = (result: [IUserBet[], IRoundBet[]]): void => {
        let myCurrentBets: IRoundBet[] = [];
        for (let bet of result[0].filter(b => !!b.roundId && !b.firstHalfCashedOut)) {
            const betInRecords: IRoundBet | undefined = result[1].find((b: IRoundBet) => b.id === bet.betIndex.toString());
            if (!betInRecords) {
                myCurrentBets.push({
                    id: bet.betIndex.toString(),
                    date: (Date.now() / 1000),
                    bet: bet.amount,
                    multiplier: undefined,
                    cashout: undefined
                });
            } else {
                myCurrentBets.push(betInRecords);
            }
        }
        this.statisticsRepository.addRemoveUserRoundBetRecords(myCurrentBets);
    };

    isRoundIdEqual(prev: IUserBet[], curr: IUserBet[]): boolean {
        let isEqual: boolean = true;
        for (let bet of prev) {
            const betInCurr: IUserBet | undefined = curr.find(b => bet.betIndex === b.betIndex);
            if (betInCurr && betInCurr.roundId !== bet.roundId) {
                isEqual = false;
                break;
            }
        }

        return isEqual;
    }
}
